import { IStrings } from 'localization/IStrings';
import { SelectableColumn } from '../SelectableColumn';

export const createColumnRecord = (strings: IStrings): Record<SelectableColumn, string> => {
	return {
		created: strings.createdAt,
		amountPaid: strings.amount,
		// cashSaleForPatientIdentifier: `${strings.patient} (${strings.cashSale})`,
		// customerAccountIdentifier: 'Klantenrekening',
		paymentDate: `${strings.date} ${strings.payment.toLowerCase()}`,
		paymentMethodIdentifier: strings.method,
		reference: strings.referenceShort,
		salesType: `${strings.type} ${strings.sale.toLowerCase()}`,
		comment: strings.remark,
	};
};
